function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
import { styled } from '@ori-ui/mui';
import useTestId from '@ori/testid-generator';
import { useConfiguration } from '../../contexts';
import { SocialMediaPlatforms } from '../../models';
import { getSocialMedia } from './getSocialMedia';
var SocialNetworkRoot = styled('div')(function(param) {
    var theme = param.theme;
    return {
        margin: theme.spacing(1, 0),
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
    };
});
var SocialNetworkWrapper = styled('div')(function() {
    return {
        textAlign: 'center'
    };
});
var ExternalProviderStyled = styled('div')(function(param) {
    var theme = param.theme;
    return {
        margin: theme.spacing(0, 0, 4),
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexWrap: 'wrap',
        gap: theme.spacing(1)
    };
});
export var SocialNetworks = function() {
    var _useTestId = useTestId(), getTestIdProps = _useTestId.getTestIdProps, getTestId = _useTestId.getTestId;
    var _useConfiguration = useConfiguration(), externalProviders = _useConfiguration.externalProviders, identityUrl = _useConfiguration.identityUrl, returnUrl = _useConfiguration.returnUrl;
    var externalProviderItems = externalProviders.map(function(item) {
        var itemProviderName = item.displayName.toLowerCase();
        var handleProviderRedirect = function() {
            var paramsObj = {
                scheme: item.authenticationScheme,
                returnUrl: returnUrl
            };
            var searchParams = new URLSearchParams(paramsObj).toString();
            var externalUrl = new URL("External/Challenge?".concat(searchParams), identityUrl);
            window.location.href = externalUrl.href;
        };
        if (itemProviderName === SocialMediaPlatforms.ActiveDirectory) {
            return null;
        }
        return /*#__PURE__*/ _jsx(SocialNetworkRoot, {
            "data-testid": getTestId("social-network-".concat(itemProviderName)),
            onClick: handleProviderRedirect,
            children: getSocialMedia(itemProviderName)
        }, itemProviderName);
    });
    return /*#__PURE__*/ _jsx(SocialNetworkWrapper, _object_spread_props(_object_spread({}, getTestIdProps('social-network')), {
        children: /*#__PURE__*/ _jsx(ExternalProviderStyled, {
            children: externalProviderItems
        })
    }));
};
